import { createAsyncThunk } from "@reduxjs/toolkit";
import { AppThunkAPIType } from "../../../app/appTypes";
import { deleteWithAuth, getWithAuth, postWithAuth, putWithAuth } from "../../../http";

export interface SystemSetting {
    id: string;
    type: string;
    code: string;
    value: string;
    isActive: boolean;
    isFixed: boolean;
    createDate: Date;
    createdBy: string;
    modifiedBy: string;
    modifyDate: Date;
}

export type DraftSystemEvent = Omit<SystemSetting, "id">

export interface SystemSettingPayload {
    id?: string;
    type: string;
    code: string;
    value: string;
    isActive: boolean;
    isFixed: boolean;
}

export const loadSystemSettings = createAsyncThunk<SystemSetting[], void, AppThunkAPIType>("system-settings/load", async (_, { dispatch, rejectWithValue, requestId, getState }) => {
    const result = await dispatch(getWithAuth({ url: `api/sys-settings` }))
    const { payload } = result
    if (getWithAuth.fulfilled.match(result)) {
        return payload as SystemSetting[]
    } else {
        return rejectWithValue(payload ?? { kind: 'unknown' })
    }
})

export const createSystemSetting = createAsyncThunk<SystemSetting, SystemSettingPayload, AppThunkAPIType>("system-settings/create", async (setting, { dispatch, rejectWithValue, requestId, getState }) => {
    const result = await dispatch(postWithAuth({ url: `api/sys-settings`, payload: setting }))
    const { payload } = result
    if (postWithAuth.fulfilled.match(result)) {
        return payload as SystemSetting
    } else {
        return rejectWithValue(payload ?? { kind: 'unknown' })
    }
})

export const updateSystemSetting = createAsyncThunk<SystemSetting, SystemSettingPayload, AppThunkAPIType>("system-settings/update", async (setting, { dispatch, rejectWithValue, requestId, getState }) => {
    const result = await dispatch(putWithAuth({ url: `api/sys-settings`, payload: setting }))
    const { payload } = result
    if (putWithAuth.fulfilled.match(result)) {
        return payload as SystemSetting
    } else {
        return rejectWithValue(payload ?? { kind: 'unknown' })
    }
})

export const deleteSystemSetting = createAsyncThunk<string, string, AppThunkAPIType>("system-settings/delete", async (id, { dispatch, rejectWithValue, requestId, getState }) => {
    const result = await dispatch(deleteWithAuth({ url: `api/sys-settings/${id}` }))
    const { payload } = result
    if (deleteWithAuth.fulfilled.match(result)) {
        return payload as string
    } else {
        return rejectWithValue(payload ?? { kind: 'unknown' })
    }
})